import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { fetchClientsService } from '../../../components/Support/services/masterData';

import type { ClientIdName } from './support.types';
import { createInitialMasterState } from './helpers';

export const fetchClientsAsyncThunk = createAsyncThunk<ClientIdName[], void>(
  'supportClients/fetchClients',
  async (_, { rejectWithValue }) => {
    const response = await fetchClientsService();
    if (!response.status || !response.data) {
      return rejectWithValue('Internal Server Error');
    }
    return response.data;
  }
);

export const clientsSlice = createSlice({
  name: 'supportClients',
  initialState: createInitialMasterState<ClientIdName>(),
  reducers: {
    clearError: state => {
      state.error = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchClientsAsyncThunk.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchClientsAsyncThunk.fulfilled,
        (state, action: PayloadAction<ClientIdName[]>) => {
          state.loading = false;
          state.data = action.payload;
        }
      )
      .addCase(fetchClientsAsyncThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const { clearError } = clientsSlice.actions;
export default clientsSlice.reducer;
